var ezdia;
(function (ezdia) {
    var NAME = 'search';
    var TYPE = 'search';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var searchQueryName = ''; // to be removed when we have project name associated with user searches
    var pageParams = {};
    var win = $(window);
    var queryrowErrorCls = 'bg-danger';
    var fieldTypes = [
        'text',
        'singlechoice',
        'date',
        'status',
        'int',
        'group',
        'tag',
        'role',
        'workflow'
    ];
    var fieldColumn = {
        editable: true,
        edittype: 'singlechoice',
        config: {
            options: {},
            deselect: 'false'
        }
    };
    var operatorsObj = {
        BTW: 'Between',
        LIKE: 'Contains',
        EQ: 'Equals',
        GT: 'Greater Than',
        IE: 'Is Empty',
        LT: 'Less Than',
        NL: 'Does Not Contain',
        NN: 'Not Empty',
        NE: 'Does Not Equal'
    };
    var changeOperators = {
        BTW: true,
        NN: true,
        IE: true
    };
    var customQueryObj = {
        name: 'custom',
        label: 'Custom search',
        query: '[{name: ""}]'
    };
    var extendedintObj = {
        edittype: 'integer',
        config: {
            decimal: true
        }
    };
    var dialogID = 'js-search-dialog-wrap';
    var dupDialogID = 'js-search-dialog-duplicate-name-wrap';
    var listBodyPrefix = 'ez-sys-js-search-list-body-';
    var exportIdPrefix = 'ez_js_sys_search_export_';
    var classes = {
        readonly: 'readonly',
        editable: 'editable',
        filterList: 'ez-search-filter-list',
        rearrangeList: 'ez-search-rearrange-list'
    };
    var DEFAULT = {
        enableadvance: true,
        enablebasic: false,
        setSelection: false,
        requestParam: null,
        searchOnLoad: false,
        useFieldsOnce: false,
        advance: {
            savedQuerys: [],
            queryfields: null,
            maxQuerys: null,
            container: '[data-search-advance=container]',
            menuBtn: '[data-search-advance-dropdown-btn=button]',
            menu: '[data-search-advance=menu]',
            menuBody: '[data-search-container="body"]',
            menuSys: '[data-search="system"]',
            menuUser: '[data-search="user"]',
            menuLabel: '[data-search-advance-selected=label]',
            andoranyWrap: '[data-search-advance="query and or any"]',
            queryContainer: '[data-search-advance=query]',
            queryrowContainer: '[data-row="query row container"]',
            queryGrpContainer: '[data-row="query group"]',
            queryrow: '[data-row=query]',
            btnsContainer: '[data-search-advance=button]',
            nameprefix: 'js-search-advance-name-',
            oprprefix: 'js-search-advance-operator-',
            valueprefix: 'js-search-advance-value-',
            lowerprefix: 'js-search-advance-lower-',
            upperprefix: 'js-search-advance-upper-',
            operand: '[data-search-advance-query=operand]',
            remove: '[data-search-advance-query=remove]',
            removeGrp: '[data-search-advance-query="remove group"]',
            add: '[data-search-advance-query=add]',
            addGrp: '[data-search-advance-query="add group"]',
            searchInput: '[data-search-advance="search input"]'
        },
        basic: {
            queryfields: null,
            container: '[data-search-basic=container]',
            nameprefix: 'js-search-basic-name-',
            oprprefix: 'js-search-basic-operator-',
            valueprefix: 'js-search-basic-value-',
            value: '__basic-search-input',
            fieldClearBtn: '[data-search-basic=btn]'
        },
        buttons: {
            search: '[data-search-advance=search]',
            saveSearch: '[data-search-advance="save search"]',
            export: '[data-search-advance="export"]',
            edit: '[data-search-advance=edit]',
            clear: '[data-search-advance=clear]',
            min: '[data-search-advance=min]'
        },
        callbacks: {
            search: function (element, query, searchUrl, event) {
                //
            },
            export: function (element, query, event) {
                //
            }
        },
        success: null,
        error: null,
        templateName: 'base-search-advanced',
        pillTemplateName: ezdia.templates.serach.pillTemplateName,
        rowTemplateName: 'base-search-advanced-query-row',
        saveTemplateName: ezdia.templates.serach.saveTemplateName,
        saveTemplateItem: ezdia.templates.serach.saveTemplateItem,
        basicSearchFieldsMarkup: ezdia.templates.serach.basicSearchFieldsMarkup,
        clsselected: 'selected'
    };
    function getSessionQuery() {
        var sessionQKey = ezdia.config.JS.sessionQKey;
        var sessionKey = ezdia.util.getUrlParam(sessionQKey);
        var sessionValue;
        if (sessionKey) {
            sessionValue = sessionStorage.getItem(sessionKey);
        }
        return sessionValue;
    }
    var Search = /** @class */ (function () {
        function Search(elem, options) {
            this.elem = elem;
            this.mergeAdvancedQuery = function (query, advancedQuery) {
                if (advancedQuery.rules) {
                    query.rules = $.merge(query.rules, advancedQuery.rules);
                    query.search_operand = advancedQuery.search_operand;
                }
                else {
                    $.each(advancedQuery, function (i, obj) {
                        if (i === 0 && obj.operand) {
                            query.search_operand = obj.operand;
                        }
                        query.rules.push({
                            field: obj
                        });
                    });
                }
            };
            this.getExtendQueryObj = function (query) {
                if (pageParams.tab === 'ExpertManagement' &&
                    pageParams.role === 'pm_customer') {
                    query.rules.push({
                        field: {
                            name: 'client_name',
                            value: encodeURIComponent(pageParams.affiliatedBy),
                            operator: 'EQ',
                            lower: '',
                            upper: '',
                            operand: 'and'
                        }
                    });
                }
                if (pageParams.isTaskFlow &&
                    pageParams.isTaskFlow === 'true' &&
                    pageParams.taskFlowId) {
                    query.rules.push({
                        field: {
                            name: 'id',
                            value: pageParams.taskFlowId,
                            operator: 'EQ',
                            lower: '',
                            upper: '',
                            operand: 'and'
                        }
                    });
                }
            };
            this.getValue = function (obj) {
                var column = obj.column, value = obj.value;
                var content = '';
                if (column && value) {
                    switch (column.edittype) {
                        case 'multichoice':
                            content = $.ezdia.multichoice.view(value, column);
                            break;
                        case 'tag':
                            content = value;
                            break;
                        case 'combo':
                            content = $.ezdia.tagInput.view(column, value);
                            break;
                        case 'date':
                            // eslint-disable-next-line no-case-declarations
                            var format = column.config.format;
                            content = $.ezdia.date.view({ format: format }, value);
                            break;
                        default:
                            content = value;
                            break;
                    }
                }
                else {
                    content = value;
                }
                return content;
            };
            this.getOperatorValue = function (value) {
                var operator = operatorsObj[value];
                if (value === 'EQ' || value === 'NE') {
                    operator += ' to';
                }
                return operator;
            };
            this.getOperatorOpt = function (type) {
                var obj = {};
                var arr = ['EQ', 'NE'];
                var arr1 = [];
                if (type === 'status' ||
                    type === 'singlechoice' ||
                    type === 'multichoice' ||
                    type === 'group' ||
                    type === 'visualstatus') {
                    arr.push('IE');
                    if (type === 'multichoice' ||
                        type === 'singlechoice' ||
                        type === 'group') {
                        arr1 = ['LIKE', 'NL'];
                    }
                }
                else {
                    arr.push('NN');
                    if (type !== 'date') {
                        arr1 = ['LIKE', 'NL'];
                    }
                    if (type === 'int' || type === 'date') {
                        arr1 = $.merge(arr1, ['GT', 'LT', 'BTW']);
                        if (type === 'date') {
                            arr.push('IE');
                        }
                    }
                    else {
                        arr.push('IE');
                    }
                }
                arr = $.merge(arr, arr1);
                $.each(operatorsObj, function (key, mval) {
                    if (arr.includes(key)) {
                        obj[key] = mval;
                    }
                });
                return obj;
            };
            this.init(options);
        }
        Object.defineProperty(Search.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        Search.prototype.getQueryString = function (qryObj) {
            var query = {
                search_operand: 'and',
                rules: []
            };
            var aQuery = {
                search_operand: 'and',
                rules: []
            };
            // eslint-disable-next-line no-param-reassign
            qryObj = qryObj || {};
            if (this.options.enablebasic) {
                if (qryObj.basicQuery) {
                    query.rules = $.merge(query.rules, qryObj.basicQuery);
                }
                else {
                    this.getBasicQuery(query);
                }
            }
            if (qryObj.advancedQuery) {
                this.mergeAdvancedQuery(aQuery, qryObj.advancedQuery);
            }
            else {
                this.getAdvancedQuery(aQuery);
            }
            if (aQuery.rules.length) {
                query.rules.push({
                    group: aQuery
                });
            }
            this.getExtendQueryObj(query);
            return query.rules.length ? JSON.stringify([query]) : '';
        };
        Search.prototype.search = function () {
            this.searchQuery();
        };
        Search.prototype.deleteQuery = function (elem) {
            var item = elem.closest('li[data-label]');
            var label = item.data('label');
            var self = this;
            this.dialog({
                title: 'Delete search query',
                html: "<p>Are you sure you want to delete <b>" + label + "</b> query?</p>",
                width: 350,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Delete',
                        click: function () {
                            deleteQueryAjax.call(self, {
                                item: item,
                                name: label
                            });
                        }
                    }
                ]
            });
        };
        Search.prototype.exports = function (element, event) {
            var query = this.getQueryString();
            if (query.error) {
                // eslint-disable-next-line no-console
                console.log('search widget exports error.');
            }
            else {
                this.options.callbacks.export.call(element, query, event);
            }
        };
        Search.prototype.setSelection = function (qname) {
            this.selectItem(qname);
        };
        Search.prototype.customSearch = function () {
            this.view('custom');
        };
        Search.prototype.getCache = function () {
            var self = this;
            var options = self.options;
            var container = self.$elem;
            var obj = {};
            var exportBtnId = exportIdPrefix + (this.elem.id || 'frm');
            if (options.enablebasic) {
                obj.basic = {
                    container: container.find(options.basic.container)
                };
            }
            if (options.enableadvance) {
                obj.advance = {
                    container: container.find(options.advance.container),
                    menuBtn: container.find(options.advance.menuBtn),
                    menu: container.find(options.advance.menu),
                    menuBody: container.find(options.advance.menuBody),
                    menuSys: container.find(options.advance.menuSys),
                    menuUser: container.find(options.advance.menuUser),
                    menuLabel: container.find(options.advance.menuLabel),
                    andoranyWrap: container.find(options.advance.andoranyWrap),
                    queryContainer: container.find(options.advance.queryContainer),
                    btnsContainer: container.find(options.advance.btnsContainer),
                    searchInput: container.find(options.advance.searchInput)
                };
                obj.template = $.ezdia.template.get(options.templateName, {
                    'advance-search-query-row-items': options.rowTemplateName,
                    'advance-search-query-pill-items': 'base-search-advanced-query-pill'
                });
                obj.pillTemplate = options.pillTemplateName;
                obj.rowTemplate = $.ezdia.template.get(options.rowTemplateName);
                obj.saveTemplate = options.saveTemplateName;
                obj.itemTemplate = options.saveTemplateItem;
            }
            obj.buttons = {
                search: container.find(options.buttons.search),
                saveSearch: container.find(options.buttons.saveSearch),
                export: container.find(options.buttons.export),
                clear: container.find(options.buttons.clear),
                min: container.find(options.buttons.min)
            };
            obj.buttons.export.attr('id', exportBtnId);
            obj.dates = [];
            obj.integer = [];
            return obj;
        };
        Search.prototype.getOptions = function (options) {
            return $.extend(true, {}, DEFAULT, this.$elem.data(), options);
        };
        Search.prototype.init = function (options) {
            this.id = this.elem.id;
            this.$elem = $(this.elem);
            this.counter = 0;
            this.queryrowsCounts = 0;
            this.maxQuerys = 0;
            this.fieldColumn = {};
            this.selectedFields = {};
            this.options = this.getOptions(options);
            this.cache = this.getCache();
            this.operatorState = [];
            this.basicFieldMap = new Map();
            this.render();
        };
        Search.prototype.render = function () {
            var options = this.options;
            var executeSys = false;
            pageParams = $.ezdia.config.pageParams || {};
            this.renderBasicSearchFieldsHtml();
            this.setAdvanceSearchFields();
            this.setAdvancePrefix();
            this.setFieldConfig();
            this.actions();
            var sessionQuery = getSessionQuery();
            if (options.requestParam || sessionQuery) {
                executeSys = this.setRequestParam(sessionQuery);
            }
            if (options.setSelection && !executeSys) {
                this.setSelection(options.setSelection);
            }
            else if (options.searchOnLoad && !executeSys) {
                this.search();
            }
        };
        Search.prototype.formatBasicSearchFieldsColModel = function (column) {
            var col = $.extend(true, {}, column);
            var edittype = column.edittype, name = column.name;
            var fieldTypesArray = [
                'text',
                'textbox',
                'role',
                'group',
                'singlechoice',
                'date',
                'status'
            ];
            var id = ezdia.util.makeId();
            var idsuffix = id.split('__').pop();
            col.name = idsuffix + "__" + name;
            col.id = ezdia.util.makeId();
            col.config = $.ezdia.getFieldsConfig(col) || {};
            col.config.cssClass = "input-sm " + this.options.basic.value;
            if (edittype === 'multichoice') {
                col.edittype = 'singlechoice';
            }
            else if (!fieldTypesArray.includes(edittype)) {
                col.edittype = 'text';
            }
            return col;
        };
        Search.prototype.renderBasicSearchFieldsHtml = function () {
            var e_1, _a;
            var enablebasic = this.options.enablebasic;
            var basicSearchFieldsModel = ezdia.config.pageParams.basicSearchFieldsModel;
            if (!enablebasic ||
                !(basicSearchFieldsModel && basicSearchFieldsModel.length)) {
                return;
            }
            var htmlContentArray = [];
            $.ezdia.widgets.load(this.id);
            try {
                for (var basicSearchFieldsModel_1 = __values(basicSearchFieldsModel), basicSearchFieldsModel_1_1 = basicSearchFieldsModel_1.next(); !basicSearchFieldsModel_1_1.done; basicSearchFieldsModel_1_1 = basicSearchFieldsModel_1.next()) {
                    var column = basicSearchFieldsModel_1_1.value;
                    var col = this.formatBasicSearchFieldsColModel(column);
                    var edittype = column.edittype, name_1 = column.name;
                    if (edittype === 'multichoice') {
                        col.config = col.config || {};
                        col.config.multiple = true;
                    }
                    var htmlInputContent = $.ezdia.inputs.create({ column: col }, this.id);
                    var htmlContent = this.options.basicSearchFieldsMarkup(col, htmlInputContent);
                    this.basicFieldMap.set(name_1, col);
                    htmlContentArray.push(htmlContent);
                    $.ezdia.widgets.init({ column: col }, this.id);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (basicSearchFieldsModel_1_1 && !basicSearchFieldsModel_1_1.done && (_a = basicSearchFieldsModel_1.return)) _a.call(basicSearchFieldsModel_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var btnId = ezdia.util.makeId();
            var clearbtn = ezdia.templates.serach.getClearBasicSearchBtn(btnId);
            htmlContentArray.push(clearbtn);
            this.cache.basic.container.html(htmlContentArray.join(''));
            this.cache.basic.clearBtn = $("#" + btnId);
            $.ezdia.widgets.create(this.id);
        };
        Search.prototype.view = function (elem) {
            var content = '';
            var advance = this.cache.advance;
            var btnWrap = advance.btnsContainer.hide();
            var andoranyWrap = advance.andoranyWrap.hide();
            var queryObj = [];
            var query = {};
            var editable = '';
            var actiontype = '';
            this.operatorState = [];
            if (typeof elem === 'string') {
                actiontype = elem === 'min' ? 'min' : 'custom';
            }
            else {
                editable = elem.data('editable');
                actiontype = elem.data('search');
            }
            if (actiontype === 'custom') {
                query = $.extend({}, {}, customQueryObj);
                this.currentQuery = query;
                editable = !query.readonly;
            }
            else if (editable || actiontype === 'min') {
                query = this.currentQuery;
            }
            else {
                query = this.getSearchConfiguration(elem) || {};
            }
            $.ezdia.widgets.load(DATA_TYPE);
            if (query.query) {
                if (typeof query.query === 'string') {
                    // tslint:disable-next-line:no-eval
                    queryObj = eval("(" + query.query + ")") || {};
                }
                else {
                    queryObj = query.query;
                }
                if (queryObj.rules) {
                    content = this.searchViewNewQuery(queryObj, editable);
                }
                else {
                    content = this.createSearchView(queryObj, editable);
                }
                this.append(content, editable);
                if (content.error) {
                    return;
                }
                if (editable) {
                    advance.container.addClass(classes.editable);
                    $.ezdia.widgets.create(DATA_TYPE);
                    this.onOffRemoveBtn();
                    btnWrap.show();
                    andoranyWrap.show();
                    if (actiontype === 'custom' && !query.dQuery) {
                        this.cache.buttons.min.hide();
                    }
                    else {
                        this.cache.buttons.min.show();
                    }
                }
                else {
                    advance.container.addClass(classes.readonly);
                    advance.container.removeClass(classes.editable);
                    if (actiontype !== 'min') {
                        this.searchQuery({
                            advancedQuery: queryObj
                        });
                    }
                }
                if (actiontype === 'custom' || !editable) {
                    advance.menuLabel.text(query.label || query.name);
                }
                if (actiontype === 'custom' &&
                    (this.advanceSearchActive || query.search)) {
                    this.searchQuery({
                        advancedQuery: query.search ? queryObj : null
                    });
                    this.resetcustomQueryObj();
                }
                else if (!editable) {
                    this.advanceSearchActive = true;
                }
                if (editable) {
                    this.validate();
                }
            }
            else {
                advance.queryContainer.html('Query is Empty!');
            }
        };
        Search.prototype.createSearchView = function (query, editable) {
            var self = this;
            var arr = [];
            var content = '';
            var error = false;
            var queryrowfn = this.getQueryReadView;
            if (editable) {
                this.reset(true);
                queryrowfn = this.getQueryEditView;
            }
            $.each(query, function (i, obj) {
                queryrowfn.call(self, obj, arr);
            });
            if (error) {
                content = {
                    error: true
                };
            }
            else {
                this.queryrowsCounts = this.maxQuerys - this.counter;
                content = this.cache.template({
                    frm: this.id,
                    editable: editable,
                    queryrowsCounts: this.queryrowsCounts,
                    searchQuerys: arr
                });
            }
            return content;
        };
        Search.prototype.getQueryReadView = function (obj, arr) {
            var self = this;
            var label = '';
            var srcColModel = this.options.advance.queryfields;
            var column = srcColModel[obj.name] || {};
            var context = {};
            label = obj.name;
            if (column) {
                label = column.label;
            }
            context = {
                name: label,
                operator: self.getOperatorValue(obj.operator),
                value: self.getValue({ column: column, value: obj.value }),
                lower: self.getValue({ column: column, value: obj.lower }),
                upper: self.getValue({ column: column, value: obj.upper })
            };
            arr.push(context);
        };
        Search.prototype.getQueryEditView = function (obj, arr) {
            var self = this;
            var srcColModel = this.options.advance.queryfields;
            var column = srcColModel[obj.name] || {};
            var context = {};
            var btwContext = {};
            var name = '';
            var operator = '';
            var error;
            name = self.getFieldInput(obj.name);
            if (name.error) {
                error = true;
                return;
            }
            if (self.options.useFieldsOnce) {
                self.selectedFields[self.counter] = obj.name;
            }
            if (column && obj.name) {
                operator = self.getOperatorInput(column.type, obj.operator);
            }
            context = {
                inputtype: column.type,
                name: name,
                operator: operator,
                operatorVal: obj.operator,
                counter: self.counter
            };
            if (obj.name) {
                self.operatorState.push(obj.operator);
                if (obj.operator === 'BTW') {
                    btwContext = self.getBetweenInput(column, obj);
                    context.lower = btwContext.lower;
                    context.upper = btwContext.upper;
                }
                else {
                    context.value = self.getValueInput({
                        col: {
                            column: column,
                            value: obj.value
                        },
                        operator: obj.operator
                    });
                }
            }
            arr.push(context);
            self.counter += 1;
        };
        Search.prototype.searchViewNewQuery = function (query, editable) {
            var self = this;
            var content = '';
            var error = false;
            var queryrowfn = this.getQueryReadView;
            this.GRPBG = false;
            if (editable) {
                self.reset(true);
                queryrowfn = this.getQueryEditView;
                content = this.createSearchViewNewEditRow(query, queryrowfn);
            }
            else {
                content = this.createSearchViewNewReadRow(query, queryrowfn);
                var t = this.cache.template({
                    editable: false
                });
                t = $(t).prepend(content);
                content = t.prop('outerHTML');
            }
            if (error) {
                content = {
                    error: true
                };
            }
            else {
                this.queryrowsCounts = this.maxQuerys - this.counter;
            }
            return content;
        };
        Search.prototype.createSearchViewNewReadRow = function (query, fn) {
            var self = this;
            var content = '';
            $.each(query.rules, function (i, obj) {
                var arr = [];
                if (obj.group) {
                    var grpContent = self.createSearchViewNewReadRow(obj.group, fn);
                    content += "<li class=\"" + obj.group.search_operand + "\"><ul class=\"list-inline\"><li class=\"grp-bracket\">(</li>" + grpContent + "<li class=\"grp-bracket\">)</li></ul></li>";
                }
                else {
                    fn.call(self, obj.field, arr);
                    var row = self.cache.pillTemplate(arr[0]);
                    content += row;
                }
            });
            return content;
        };
        Search.prototype.createSearchViewNewEditRow = function (query, fn, grp) {
            var _this = this;
            var context = {
                frm: this.id,
                editable: true,
                addrow: !grp,
                grp: grp,
                bg: this.GRPBG,
                operand: query.search_operand || '',
                searchQuerys: []
            };
            var content = this.cache.template(context);
            content = $(content);
            $.each(query.rules, function (i, obj) {
                var arr = [];
                if (obj.group) {
                    _this.GRPBG = !_this.GRPBG;
                    var grpContent = _this.createSearchViewNewEditRow(obj.group, fn, true);
                    content
                        .find(_this.options.advance.queryrowContainer)
                        .append(grpContent);
                }
                else {
                    fn.call(_this, obj.field, arr);
                    var rowObj = $.extend(arr[0], {
                        frm: _this.id,
                        counter: _this.counter - 1
                    });
                    var row = _this.cache.rowTemplate(rowObj);
                    content.find(_this.options.advance.queryrowContainer).append(row);
                }
            });
            return content.prop('outerHTML');
        };
        Search.prototype.append = function (content, editable) {
            var context = content;
            if (typeof content !== 'string') {
                context = 'Error in your configuration. Please contact support.';
            }
            this.cache.advance.queryContainer.html(context).data('mode', editable);
            if (editable && this.options.useFieldsOnce) {
                this.disableOptions();
            }
            if (editable) {
                this.onOffAddBtn();
            }
        };
        Search.prototype.removeQueryRow = function (element) {
            var queryrow = $(element).closest(this.options.advance.queryrow);
            var index = queryrow.data('index');
            queryrow.remove();
            this.onOffRemoveBtn();
            this.onOffAddBtn('remove');
            if (this.options.useFieldsOnce) {
                this.disableOptions({
                    type: 'remove',
                    index: index
                });
            }
        };
        Search.prototype.removeGrpQueryRow = function (element) {
            var self = this;
            var advance = this.options.advance;
            var elem = $(element);
            var queryGrpContainer = elem.closest(advance.queryGrpContainer);
            if (queryGrpContainer.siblings().length === 0) {
                //
            }
            else {
                this.dialog({
                    html: '<p>Are you sure you want to delete this query group?</p>',
                    width: 350,
                    height: 230,
                    buttons: [
                        {
                            text: 'Cancel',
                            class: 'btn-link',
                            click: function () {
                                $(this).dialog('close');
                            }
                        },
                        {
                            text: 'Ok',
                            click: function () {
                                var removeBtn = queryGrpContainer.find(advance.remove);
                                $.each(removeBtn, function each() {
                                    $(this).trigger('click');
                                });
                                queryGrpContainer.remove();
                                self.onOffRemoveBtn();
                                $(this).dialog('close');
                            }
                        }
                    ]
                });
            }
        };
        Search.prototype.addQueryRow = function (element, grp) {
            var elem = $(element);
            var row = elem.closest('[data-row=row]');
            var content = '';
            var template = 'rowTemplate';
            var context = {
                frm: this.id,
                editable: true,
                addrow: !grp,
                grp: grp,
                searchQuerys: []
            };
            var wrap = row.prev(this.options.advance.queryrowContainer);
            $.ezdia.widgets.load(DATA_TYPE);
            var contextRow = {
                name: this.getFieldInput(),
                counter: this.counter
            };
            if (grp) {
                context.bg = !wrap.parent().hasClass('ez-bg-dark');
                template = 'template';
                context.searchQuerys.push(contextRow);
            }
            else {
                context = $.extend(context, contextRow);
            }
            content = this.cache[template](context);
            wrap.append(content);
            $.ezdia.widgets.create(DATA_TYPE);
            this.onOffRemoveBtn();
            this.onOffAddBtn('add');
            if (this.options.useFieldsOnce) {
                this.disableOptions({
                    type: 'add'
                });
            }
            this.counter += 1;
        };
        Search.prototype.searchQuery = function (qryObj) {
            var query = this.getQueryString(qryObj);
            // tslint:disable-next-line:no-empty
            if (query.error) {
                //
            }
            else {
                this.options.callbacks.search(query, searchQueryName, this.options.searchUrl, this);
                searchQueryName = '';
            }
        };
        Search.prototype.saveAndSearch = function () {
            var self = this;
            var query = {
                rules: []
            };
            var saveTemplate = null;
            this.getAdvancedQuery(query);
            if (!query.rules.length) {
                this.dialog({
                    html: 'Please provide valid search criteria!!',
                    buttons: {
                        Ok: function () {
                            $(this).dialog('close');
                        }
                    }
                });
                return;
            }
            saveTemplate = this.cache.saveTemplate;
            this.dialog({
                html: saveTemplate(),
                width: 350,
                height: 230,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Save',
                        click: function () {
                            self.saveQuery({
                                query: JSON.stringify(query)
                            }, this);
                        }
                    }
                ]
            });
        };
        Search.prototype.saveQuery = function (options, wrap) {
            var self = this;
            var name = $('#save_search_query').val();
            name = name.trim();
            if (!options.override) {
                if (!name) {
                    $(wrap)
                        .find('[data-container="msg"]')
                        .addClass('bg-danger')
                        .text('Query Name is Empty!');
                    return;
                }
                if (this.options.advance.savedQuerys.includes(name)) {
                    this.dialog({
                        id: dupDialogID,
                        title: 'Do you want to override ?',
                        html: '<br><p>You already have a saved query with same name.</p><p>Do you want to override ?</p>',
                        buttons: [
                            {
                                text: 'Cancel',
                                class: 'btn-link',
                                click: function () {
                                    $(this).dialog('close');
                                }
                            },
                            {
                                text: 'Override',
                                click: function () {
                                    self.saveQuery({
                                        query: options.query,
                                        override: true
                                    });
                                    $(this).dialog('close');
                                }
                            }
                        ]
                    });
                    return;
                }
            }
            options.name = name;
            saveQueryAjax.call(this, options);
        };
        Search.prototype.saveQuerySuccess = function (options) {
            var tab = pageParams.tab || $('#tabVal').val();
            if (tab === 'ExpertManagement') {
                $('#tool_name').val($('#assignment_tool_name').val());
                $('#tool_role').val($('#assignment_role_name').val());
                $('#gridForm').submit();
            }
            else {
                this.updateQueryList(options);
            }
        };
        Search.prototype.updateQueryList = function (options) {
            var menuUser = this.cache.advance.menuUser;
            var query = decodeURIComponent(options.query);
            var content = '';
            var value;
            if (!options.override) {
                content = this.cache.itemTemplate(options);
                menuUser.append(content);
            }
            var item = menuUser.find("li[data-label=\"" + options.name + "\"]");
            var input = item.find('input[type=hidden]');
            if (!options.override) {
                value = {
                    name: options.name,
                    label: options.name,
                    override: false
                };
                this.options.advance.savedQuerys.push(options.name);
                menuUser.show();
            }
            else {
                value = input.val();
                value = $.ezdia.getJsonObject(value);
            }
            value.query = query;
            value = JSON.stringify(value);
            input.val(value);
            if (!options.override) {
                item.trigger('click');
            }
        };
        Search.prototype.deleteQuerySuccess = function (options) {
            var active = options.item.hasClass(this.options.clsselected);
            var menuUser = this.cache.advance.menuUser;
            var index = this.options.advance.savedQuerys.indexOf(options.name);
            var len = 2;
            if (options.templateName === 'desk') {
                options.item.remove();
            }
            if (active) {
                this.clearSearch();
            }
            this.options.advance.savedQuerys.splice(index, 1);
            len = menuUser.find('li').length;
            if (len === 1) {
                menuUser.hide();
            }
            this.dialog({
                title: 'Delete search query',
                html: "<p><b>" + options.name + "</b> query has been deleted successfully.<p>",
                width: 350,
                buttons: [
                    {
                        text: 'Ok',
                        click: function () {
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        Search.prototype.clear = function () {
            var self = this;
            this.dialog({
                title: 'Clear search',
                width: 350,
                height: 180,
                html: '<p>Are you sure you want to clear this search criteria?</p>',
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Clear',
                        click: function () {
                            self.clearSearch();
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        Search.prototype.clearSearch = function () {
            var self = this;
            var cache = self.cache.advance;
            cache.menu
                .find('li, a[data-search="custom"]')
                .removeClass(self.options.clsselected);
            cache.container
                .removeClass(classes.readonly)
                .removeClass(classes.editable);
            cache.queryContainer.empty();
            cache.btnsContainer.hide();
            cache.andoranyWrap.hide();
            cache.menuLabel.text('No filters applied');
            self.advanceSearchActive = false;
            this.resetcustomQueryObj();
            this.currentQuery.query = null;
            self.searchQuery([]);
        };
        Search.prototype.updateOperatorInput = function (element) {
            var elem = $(element);
            var advance = this.options.advance;
            var row = elem.closest(advance.queryrow);
            var index = row.data('index');
            var value = elem.val();
            var oldvalue = '';
            var column = advance.queryfields[value];
            var context = '';
            if (!column) {
                return;
            }
            if (this.options.useFieldsOnce) {
                oldvalue = this.selectedFields[index];
                this.selectedFields[index] = value;
                this.disableOptions.call({
                    type: 'update',
                    option: oldvalue
                });
            }
            $.ezdia.widgets.load(DATA_TYPE);
            row.attr('data-input', column.type);
            context = this.getOperatorInput(column.type, '', index);
            $("#" + this.options.advance.oprprefix + "row-" + index).html(context);
            $.ezdia.widgets.create(DATA_TYPE);
        };
        Search.prototype.updateValueInput = function (element, isnew) {
            var advance = this.options.advance;
            var operator = element.value;
            var row = $(element).closest(advance.queryrow);
            var index = row.data('index');
            var oldOpr = this.operatorState[index];
            if (!isnew &&
                oldOpr &&
                !changeOperators[operator] &&
                !changeOperators[oldOpr]) {
                return;
            }
            this.operatorState[index] = operator;
            var value = $("#" + advance.nameprefix + index).val();
            var column = advance.queryfields[value];
            var suffix = "row-" + index;
            var valContainer = row
                .find("#" + advance.valueprefix + suffix)
                .hide()
                .empty();
            var lowerContainer = row
                .find("#" + advance.lowerprefix + suffix)
                .hide()
                .empty();
            var upperContainer = row
                .find("#" + advance.upperprefix + suffix)
                .hide()
                .empty();
            var content = '';
            this.cache.dates = [];
            $.ezdia.widgets.load(DATA_TYPE);
            row.attr('data-operator', operator);
            if (operator === 'BTW') {
                content = this.getBetweenInput(column, {
                    operator: operator,
                    index: index
                });
                lowerContainer.html(content.lower).show();
                upperContainer.html(content.upper).show();
            }
            else {
                content = this.getValueInput({
                    col: {
                        column: column
                    },
                    operator: operator,
                    index: index
                });
                valContainer.html(content).show();
            }
            if (content) {
                $.ezdia.widgets.create(DATA_TYPE);
                this.validate();
            }
        };
        Search.prototype.getBasicQuery = function (query) {
            var self = this;
            var wrapper = this.cache.basic.container;
            var clearBtn = this.cache.basic.clearBtn;
            var basicOpt = this.options.basic;
            var inputs = wrapper.find("." + basicOpt.value + ":not(\".tt-input\")");
            var isBasciSearch = false;
            $.each(inputs, function each() {
                var e_2, _a;
                var value = this.value;
                if (!value) {
                    return;
                }
                isBasciSearch = true;
                var name = this.name.split('__').pop();
                var config = self.basicFieldMap.get(name).config;
                var _b = config.gridFilter, gridFilter = _b === void 0 ? {} : _b;
                var operator = gridFilter.operator;
                if (this.multiple) {
                    value = __spread(this.options).filter(function (option) { return option.selected; })
                        .map(function (option) { return option.value; });
                    var rules = [];
                    try {
                        for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                            var val = value_1_1.value;
                            rules.push({
                                field: {
                                    name: name,
                                    value: encodeURIComponent(val),
                                    operator: operator || 'LIKE',
                                    lower: '',
                                    upper: ''
                                }
                            });
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    query.rules.push({
                        group: {
                            search_operand: 'or',
                            rules: rules
                        }
                    });
                }
                else {
                    query.rules.push({
                        field: {
                            name: name,
                            value: encodeURIComponent(value),
                            operator: operator || 'EQ',
                            lower: '',
                            upper: ''
                        }
                    });
                }
            });
            if (isBasciSearch && clearBtn) {
                clearBtn.removeAttr('disabled');
            }
            else if (clearBtn) {
                clearBtn.attr('disabled', 'disabled');
            }
        };
        Search.prototype.getAdvancedQuery = function (query) {
            var advance = this.options.advance;
            var wrapper = this.cache.advance.container;
            var rows = wrapper.find(advance.queryrow);
            var advanceMenu = this.cache.advance.menu;
            var queryContainer = wrapper.find(advance.queryContainer);
            var queryrowContainer = queryContainer.find("> .ez-search-advanced-query-row-container > " + advance.queryrowContainer);
            var queryObject = {
                search_operand: '',
                rules: []
            };
            if (rows.length) {
                queryObject.search_operand = $('#srchOperand').val();
                this.getAdvancedQueryObject(queryrowContainer, queryObject.rules);
                if (queryObject.rules.length) {
                    query.rules = queryObject.rules;
                    query.search_operand = queryObject.search_operand;
                }
            }
            else if (advanceMenu.length) {
                var selectedSearch = advanceMenu.find("." + this.options.clsselected);
                if (selectedSearch.length && this.currentQuery.query) {
                    var queryObj = [];
                    if (typeof this.currentQuery.query === 'string') {
                        // tslint:disable-next-line:no-eval
                        queryObj = eval("(" + this.currentQuery.query + ")") || [];
                    }
                    else {
                        queryObj = this.currentQuery.query;
                    }
                    this.mergeAdvancedQuery(query, queryObj);
                }
            }
        };
        Search.prototype.getAdvancedQueryObject = function (queryrowContainer, queryObject) {
            var self = this;
            var advance = this.options.advance;
            var rows = queryrowContainer.find("> " + advance.queryrow + ", > " + advance.queryGrpContainer);
            var error = false;
            $.each(rows, function eachrows() {
                var row = $(this);
                var rowType = row.data('row');
                if (rowType === 'query') {
                    error = self.getAdvancedRowQuery(row, queryObject);
                    if (error) {
                        // return false;
                    }
                }
                else {
                    var groupQueryrowContainer = row.find("> " + advance.queryrowContainer);
                    var operand = groupQueryrowContainer.find(advance.operand).val();
                    var groupQueryObj = {
                        group: {
                            search_operand: operand,
                            rules: []
                        }
                    };
                    self.getAdvancedQueryObject(groupQueryrowContainer, groupQueryObj.group.rules);
                    if (groupQueryObj.group.rules.length) {
                        queryObject.push(groupQueryObj);
                    }
                }
            });
            // return error;
        };
        // eslint-disable-next-line consistent-return
        Search.prototype.getAdvancedRowQuery = function (row, query) {
            var advance = this.options.advance;
            var objQ = {};
            var index = row.data('index');
            var name = row
                .find("[name=" + advance.nameprefix + index + "]")
                .val();
            var column = advance.queryfields[name];
            var value = '';
            if (!name) {
                return true;
            }
            if (column.type === 'tag') {
                value = row.find("[name=" + advance.valueprefix + index + "]").val() || '';
                value = value.split(',') || [''];
            }
            else {
                value = [''];
            }
            $.each(value, function (i, mval) {
                objQ = getQueryRowObj.call(row, advance, index, mval);
                if (objQ) {
                    objQ = $.extend(objQ, {
                        name: name
                    });
                    query.push({
                        field: objQ
                    });
                }
            });
        };
        Search.prototype.getFieldInput = function (value) {
            var content = '';
            if (!$.isEmptyObject(this.fieldColumn.config.options)) {
                this.fieldColumn.name = this.options.advance.nameprefix + this.counter;
                var obj = {
                    column: this.fieldColumn,
                    value: value || ''
                };
                $.ezdia.widgets.init(obj, DATA_TYPE);
                content = $.ezdia.inputs.singlechoice(obj);
            }
            else {
                content = {
                    error: true
                };
            }
            return content;
        };
        Search.prototype.getOperatorInput = function (type, value, index) {
            var column = {
                name: this.options.advance.oprprefix +
                    (index !== undefined ? index : this.counter),
                editable: true,
                edittype: 'singlechoice',
                placeholder: 'Operator',
                config: {
                    options: this.getOperatorOpt(type),
                    deselect: 'false'
                }
            };
            var obj = {
                column: column,
                // eslint-disable-next-line no-nested-ternary
                value: !value
                    ? type === 'tag' || type === 'multichoice'
                        ? 'LIKE'
                        : 'EQ'
                    : value
            };
            $.ezdia.widgets.init(obj, DATA_TYPE);
            return $.ezdia.inputs.singlechoice(obj);
        };
        Search.prototype.getValueInput = function (contextObj) {
            var obj = contextObj.col;
            var operator = contextObj.operator;
            var index = contextObj.index !== undefined ? contextObj.index : this.counter;
            var content = '';
            var advance = this.options.advance;
            var type = obj.column.edittype || obj.column.type;
            if (type === 'role' || type === 'group') {
                $.extend(true, obj.column.config, {
                    userInput: true
                });
            }
            if (operator !== 'NN' && operator !== 'IE') {
                obj.column.editable = true;
                if (type === 'multichoice') {
                    type = 'singlechoice';
                }
                else if (type === 'date') {
                    obj.column.config = $.extend(true, {}, {
                        backDate: true,
                        displayTime: false
                    });
                }
                obj.column.edittype = type;
                if (operator === 'BTW') {
                    obj.column.name =
                        (contextObj.lower ? advance.lowerprefix : advance.upperprefix) +
                            index;
                }
                else {
                    obj.column.name = advance.valueprefix + index;
                }
                $.ezdia.widgets.init(obj, DATA_TYPE);
                content = $.ezdia.inputs.create(obj);
            }
            return content;
        };
        Search.prototype.getBetweenInput = function (column, obj) {
            var context = {
                col: {
                    value: obj.upper
                },
                operator: obj.operator,
                index: obj.index
            };
            var collower = $.extend(true, {}, column);
            var colupper = $.extend(true, {}, column);
            var content = {};
            var index = obj.index !== undefined ? obj.index : this.counter;
            if (column.type === 'int') {
                collower = $.extend(true, {}, collower, extendedintObj, {
                    placeholder: 'Lower'
                });
                colupper = $.extend(true, {}, colupper, extendedintObj, {
                    placeholder: 'Upper'
                });
                this.cache.integer.push(index);
            }
            else if (column.type === 'date') {
                this.cache.dates.push(index);
                $.extend(true, collower, { readonly: true });
                $.extend(true, colupper, { readonly: true });
            }
            context.col.column = colupper;
            content.upper = this.getValueInput(context);
            context.col.column = collower;
            context.lower = true;
            context.col.value = obj.lower;
            content.lower = this.getValueInput(context);
            return content;
        };
        Search.prototype.getSearchConfiguration = function (elem) {
            var input = elem.find('input[type=hidden]');
            var query = input.val();
            var queryQuery = [];
            var state = false;
            if (!query) {
                query = {};
            }
            else {
                this.currentQuery = [];
                query = $.ezdia.getJsonObject(query);
                // tslint:disable-next-line:no-eval
                queryQuery =
                    $.ezdia.getJsonObject(query.query) || eval(query.query) || [];
                $.each(queryQuery, function (i, qry) {
                    if (qry.name === 'state') {
                        qry.name = pageParams.submitFields || '';
                        qry.operator = qry.operator || 'EQ';
                        qry.operand = qry.operand || 'and';
                        state = true;
                    }
                });
                if (state) {
                    query.query = JSON.stringify(queryQuery);
                }
                this.currentQuery = query;
            }
            return query;
        };
        Search.prototype.setRequestParam = function (sessionQuery) {
            var _this = this;
            var isFilter = false;
            var executeSys = false;
            var basicSearchFields;
            var options = this.options;
            var reqParam = ezdia.util.jsonParse(options.requestParam) || {};
            var sessionParams = ezdia.util.jsonParse(sessionQuery) || {};
            var queryParams = __assign(__assign({}, reqParam), sessionParams);
            var srcColModel = options.advance.queryfields;
            var query = [];
            if (options.enablebasic) {
                basicSearchFields =
                    options.basic.queryfields || pageParams.basicSearchFields || '';
                basicSearchFields =
                    typeof basicSearchFields === 'string'
                        ? basicSearchFields.split(', ')
                        : basicSearchFields;
            }
            if (reqParam.filter) {
                var ssQuery = this.getLsFilterQuery(reqParam.filter[0]);
                if (ssQuery) {
                    isFilter = true;
                    query = this.formatStringTemplate(ssQuery, reqParam);
                }
                else {
                    query = [];
                }
            }
            else {
                Object.entries(queryParams).forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], qValue = _b[1];
                    var index = -1;
                    var value;
                    if (typeof qValue === 'string') {
                        value = qValue;
                    }
                    else {
                        value = qValue ? qValue[0] : '';
                    }
                    if (!key) {
                        return;
                    }
                    if (key === 'state') {
                        // eslint-disable-next-line no-param-reassign
                        key = pageParams.submitFields || '';
                    }
                    value = value.replace(/</g, '%3C').replace(/>/g, '%3E');
                    if (options.enablebasic) {
                        index = basicSearchFields.indexOf(key);
                        if (index !== -1) {
                            var elem = $("[name$=__" + key + "]");
                            if (elem.length) {
                                var _c = _this.basicFieldMap.get(key) || {}, edittype = _c.edittype, id = _c.id;
                                var elemId = elem.attr('id');
                                elem.val(value);
                                _this.setBasicActiveClass(elem[0], value);
                                $.ezdia.inputs.setValue({
                                    id: "#" + id || "#" + elemId,
                                    value: value,
                                    type: edittype
                                });
                            }
                            executeSys = true;
                        }
                    }
                    if (index === -1 && srcColModel[key]) {
                        query.push({
                            name: key,
                            operator: 'EQ',
                            value: value,
                            lower: '',
                            upper: ''
                        });
                    }
                });
            }
            if (isFilter || query.length) {
                this.resetcustomQueryObj(query);
                this.cache.advance.menu.find('[data-search="custom"]').trigger('click');
                executeSys = true;
            }
            else if (executeSys) {
                this.search();
            }
            return executeSys;
        };
        Search.prototype.getLsFilterQuery = function (filterName) {
            var ssQuery = sessionStorage.getItem(filterName);
            if (!ssQuery) {
                var lsQuery = localStorage.getItem(filterName);
                if (lsQuery) {
                    sessionStorage.setItem(filterName, lsQuery);
                    ssQuery = lsQuery;
                }
            }
            return ssQuery || '';
        };
        Search.prototype.formatStringTemplate = function (query, reqParam) {
            var retVal = '';
            try {
                var names = Object.keys(reqParam);
                var vals = Object.values(reqParam);
                // eslint-disable-next-line no-new-func
                retVal = new (Function.bind.apply(Function, __spread([void 0], names, ["return `" + query + "`;"])))().apply(void 0, __spread(vals));
            }
            catch (ex) {
                // eslint-disable-next-line no-console
                console.warn(ex);
            }
            return retVal;
        };
        Search.prototype.selectItem = function (qname) {
            var menu = this.cache.advance.menu;
            var searchQueryItem = null;
            if (!menu.length && !qname) {
                return;
            }
            if (typeof qname === 'boolean') {
                searchQueryItem = menu.find('[data-search="system"] li').first();
            }
            else {
                searchQueryItem = menu.find("ul[data-search=\"system\"] li[data-label=\"" + qname + "\"]");
            }
            if (searchQueryItem.length) {
                searchQueryItem.trigger('click');
            }
            else {
                this.search();
            }
        };
        Search.prototype.setAdvanceSearchFields = function () {
            var advance = this.options.advance;
            var queryfields = {};
            if (advance.queryfields) {
                queryfields = advance.queryfields;
            }
            else {
                queryfields = pageParams.searchFieldsJson;
            }
            advance.queryfields = $.ezdia.getJsonObject(queryfields) || {};
            queryfields = {};
            $.each(advance.queryfields, function (key, column) {
                var type = column.type || column.edittype;
                if (!fieldTypes.includes(type)) {
                    column.type = 'text';
                }
                else {
                    column.type = type;
                }
                column.edittype = column.type;
                column.config = $.ezdia.getFieldsConfig(column);
                column.config = column.config || column.configMap || {};
            });
        };
        Search.prototype.setFieldConfig = function () {
            var self = this;
            var count = 0;
            var maxQuery = this.options.advance.maxQuerys;
            this.fieldColumn = $.extend(true, {}, fieldColumn);
            $.each(this.options.advance.queryfields, function (key, obj) {
                count += 1;
                self.fieldColumn.config.options[key] = obj.label;
            });
            if (maxQuery || this.options.useFieldsOnce) {
                this.maxQuerys = maxQuery || count;
            }
        };
        Search.prototype.setActiveItem = function (element) {
            var menu = this.cache.advance.menu;
            var cls = this.options.clsselected;
            menu.find("." + cls).removeClass(cls);
            element.addClass(cls);
        };
        Search.prototype.setAdvancePrefix = function () {
            var advance = this.options.advance;
            var id = this.id + "-";
            advance.nameprefix = "js-search-advance-name-" + id;
            advance.oprprefix = "js-search-advance-operator-" + id;
            advance.valueprefix = "js-search-advance-value-" + id;
            advance.lowerprefix = "js-search-advance-lower-" + id;
            advance.upperprefix = "js-search-advance-upper-" + id;
        };
        Search.prototype.validate = function () {
            var cacheObj = this.cache;
            if (cacheObj.dates.length) {
                this.dateValidate(cacheObj.dates);
            }
            else if (cacheObj.integer) {
                this.validateInteger(cacheObj.integer);
            }
        };
        Search.prototype.valid = function () {
            var advance = this.options.advance;
            var wrapper = this.cache.advance.container;
            var introws = wrapper.find(advance.queryrow + "[data-input=int][data-operator=BTW]");
            var error = false;
            if (introws.length) {
                error = this.validateInteger(introws);
            }
            if (error) {
                this.dialog({
                    title: 'Query Status',
                    html: 'You have an error in your QUERY syntax.',
                    buttons: {
                        Ok: function () {
                            $(this).dialog('close');
                        }
                    }
                });
            }
            return error;
        };
        Search.prototype.validateInteger = function (rows) {
            var advance = this.options.advance;
            var error = false;
            $.each(rows, function eachrows() {
                var row = $(this);
                var index = row.data('index');
                var lower = row.find("#" + advance.lowerprefix + index).val();
                var upper = row.find("#" + advance.upperprefix + index).val();
                lower = lower ? +lower : 0;
                upper = upper ? +upper : 0;
                if ((lower && !upper) || (!lower && upper) || lower > upper) {
                    error = true;
                    row.addClass(queryrowErrorCls);
                    return;
                }
                row.removeClass(queryrowErrorCls);
            });
            return error;
        };
        Search.prototype.dateValidate = function (arr) {
            var advance = this.options.advance;
            $.each(arr, function (i, counter) {
                var lower = $("#" + advance.lowerprefix + counter);
                var upper = $("#" + advance.upperprefix + counter);
                lower.on("change." + DATA_TYPE, function change() {
                    var date = getDate.call(this, 1);
                    var vals = upper.val();
                    upper.datepicker('option', 'minDate', date);
                    if (!vals) {
                        upper.datepicker('setDate', date);
                    }
                });
                upper.on("change." + DATA_TYPE, function change() {
                    var date = getDate.call(this, -1);
                    var vals = lower.val();
                    if (!vals) {
                        lower.datepicker('setDate', date).trigger('change');
                    }
                });
            });
        };
        Search.prototype.dialog = function (options) {
            var wrap = $.ezdia.getWrapper(options.id || dialogID);
            var dOptions = {
                closeOnEscape: false,
                open: function (e, ui) {
                    $('.ui-dialog-titlebar-close', ui.dialog || ui).hide();
                },
                modal: true,
                title: 'Search Query',
                width: 300,
                height: 200,
                buttons: []
            };
            dOptions = $.extend(true, {}, dOptions, options);
            wrap.html(options.html);
            wrap.dialog(dOptions);
        };
        Search.prototype.setBasicActiveClass = function (elem, prevalue) {
            var value = elem.value;
            var parent = $(elem).closest('.form-group');
            if (!value && !prevalue) {
                parent.removeClass(this.options.clsselected);
            }
            else {
                parent.addClass(this.options.clsselected);
            }
        };
        // ACTIONS FUNCTIONS
        // =========================
        Search.prototype.dropDownAction = function () {
            var self = this;
            var menuClick = "click.ez.search.dropdown" + DATA_TYPE;
            var menuBtn = this.cache.advance.menuBtn;
            var btnParent = menuBtn.parent();
            menuBtn.on("click." + DATA_TYPE, function () {
                var justClicked = true;
                btnParent.addClass('open');
                win.off(menuClick).on(menuClick, function (e) {
                    if (!justClicked &&
                        !$(e.target).closest(self.options.advance.searchInput).length) {
                        btnParent.removeClass('open');
                    }
                    justClicked = false;
                });
            });
        };
        Search.prototype.actionFilterList = function () {
            var cadvance = this.cache.advance;
            var listBodyId = listBodyPrefix + this.id;
            var items = 'li:not(.heading)';
            var itemsLen = cadvance.menu.find(items).length;
            if (itemsLen > 9) {
                cadvance.menuBody.attr('id', listBodyId);
                cadvance.searchInput.filterSearch({
                    items: 'li:not(.heading)',
                    container: "#" + listBodyId
                });
                cadvance.menu.addClass(classes.filterList);
            }
        };
        Search.prototype.actionRearrange = function () {
            var self = this;
            var cadvance = this.cache.advance;
            var menu = cadvance.menu;
            var itemsLen = cadvance.menuUser.find('li').length;
            if (itemsLen > 9) {
                menu.addClass(classes.rearrangeList);
                cadvance.menu
                    .find('[data-search="rearrange"]')
                    .on("click." + DATA_TYPE, function () {
                    self.rearrange();
                });
            }
        };
        Search.prototype.updateUrlQuery = function (event) {
            var e_3, _a, e_4, _b;
            var url = new URL(window.location.href);
            var searchParams = url.searchParams;
            var target = event.target;
            var _c = target, inputName = _c.name, value = _c.value;
            var query = {
                rules: []
            };
            this.getBasicQuery(query);
            var rules = query.rules;
            var isValue = value !== null && value !== void 0 ? value : '';
            if (!isValue) {
                var _d = __read(inputName.split('__'), 2), queryKey = _d[1];
                searchParams.delete(queryKey);
            }
            else if (rules.length) {
                try {
                    for (var rules_1 = __values(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()) {
                        var _e = rules_1_1.value, field = _e.field, group = _e.group;
                        if (group) {
                            var grules = group.rules;
                            var gname = '';
                            var gquery = [];
                            try {
                                for (var grules_1 = (e_4 = void 0, __values(grules)), grules_1_1 = grules_1.next(); !grules_1_1.done; grules_1_1 = grules_1.next()) {
                                    var gfield = grules_1_1.value.field;
                                    var name_2 = gfield.name, qValue = gfield.value;
                                    gname = name_2;
                                    gquery.push(qValue);
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (grules_1_1 && !grules_1_1.done && (_b = grules_1.return)) _b.call(grules_1);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                            searchParams.set(gname, decodeURIComponent(gquery.join(',')));
                        }
                        else {
                            var name_3 = field.name, queryf = field.value;
                            searchParams.set(name_3, decodeURIComponent(queryf));
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (rules_1_1 && !rules_1_1.done && (_a = rules_1.return)) _a.call(rules_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
            var newUrl = url.toString();
            window.history.pushState({}, '', newUrl);
        };
        Search.prototype.actions = function () {
            var _this = this;
            var self = this;
            var _a = this, options = _a.options, cache = _a.cache;
            var type = DATA_TYPE;
            var menu = null;
            var btns = cache.buttons;
            if (options.enablebasic) {
                setTimeout(function () {
                    cache.basic.container
                        .find("." + options.basic.value + ":not(\".tt-input\")")
                        .on("change." + type, function (e) {
                        _this.setBasicActiveClass(e.currentTarget);
                        _this.searchQuery();
                        _this.updateUrlQuery(e);
                    });
                    cache.basic.container
                        .find(options.basic.fieldClearBtn)
                        .on("click." + type, function (e) {
                        _this.clearField(e);
                    });
                }, 0);
                if (this.cache.basic.clearBtn) {
                    this.cache.basic.clearBtn.on('click', this.clearBasicSearch.bind(this));
                }
            }
            if (options.enableadvance) {
                menu = cache.advance.menu;
                if (menu) {
                    this.dropDownAction();
                    this.actionFilterList();
                    this.actionRearrange();
                    menu
                        .on("click." + type, 'li:not(.heading), [data-search="custom"]', function click() {
                        var elem = $(this);
                        var cls = self.options.clsselected;
                        if (elem.hasClass(cls)) {
                            return;
                        }
                        self.setActiveItem(elem);
                        self.view(elem);
                    })
                        .on("click." + type, '[data-search-advance-item=delete]', function click(e) {
                        e.stopPropagation();
                        self.deleteQuery($(this));
                    });
                }
            }
            btns.search.on("click." + type, function () {
                var error = _this.valid();
                if (!error) {
                    _this.searchQuery();
                }
            });
            btns.saveSearch.on("click." + type, function () {
                var error = _this.valid();
                if (!error) {
                    _this.saveAndSearch();
                }
            });
            btns.export.on("click." + type, function click(event) {
                var error = self.valid();
                if (!error) {
                    self.exports(this, event);
                }
            });
            btns.clear.on("click." + type, $.proxy(this.clear, this));
            btns.min.on("click." + type, this.view.bind(this, 'min'));
            cache.advance.queryContainer
                .on("click." + type, options.buttons.edit, function click() {
                var elem = $(this);
                self.view(elem);
            })
                .on("click." + type, options.buttons.clear, $.proxy(this.clear, this))
                .on("change." + type, "select[name^=" + options.advance.nameprefix + "]", function change() {
                self.updateOperatorInput(this);
                self.updateValueInput(this, true);
            })
                .on("change." + type, "select[name^=" + options.advance.oprprefix + "]", function change() {
                self.updateValueInput(this);
            })
                .on("click." + type, options.advance.remove, function click() {
                self.removeQueryRow(this);
            })
                .on("click." + type, options.advance.removeGrp, function click() {
                self.removeGrpQueryRow(this);
            })
                .on("click." + type, options.advance.add, function click() {
                self.addQueryRow(this);
            })
                .on("click." + type, options.advance.addGrp, function click() {
                self.addQueryRow(this, true);
            });
            window.addEventListener('popstate', function () {
                window.location.reload();
            });
        };
        Search.prototype.clearBasicSearch = function (event) {
            var e_5, _a;
            var url = new URL(window.location.href);
            var searchParams = url.searchParams;
            try {
                for (var _b = __values(this.basicFieldMap), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), column = _d[1];
                    var name_4 = column.name;
                    var querykey = name_4.split('__').pop();
                    searchParams.delete(querykey);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            window.location.href = url.toString();
        };
        Search.prototype.clearField = function (event) {
            var currentTarget = event.currentTarget;
            var _a = $(currentTarget).data(), type = _a.type, id = _a.id;
            var $input = $("#" + id);
            if (type !== 'text') {
                $input.typeahead('val', '');
            }
            $input.val('').trigger('change');
        };
        Search.prototype.disableOptions = function (obj) {
            var criteria = "select[id^=" + this.options.advance.nameprefix + "]";
            var options = '';
            // eslint-disable-next-line no-param-reassign
            obj = obj || {};
            if (obj.type !== 'remove') {
                $.each(this.selectedFields, function (i, name) {
                    if (options) {
                        options += ', ';
                    }
                    options += "option[value=\"" + name + "\"]:not(\":selected\")";
                });
            }
            if (obj.type === 'add') {
                criteria = "select[id=" + this.options.advance.nameprefix + this.counter + "]";
            }
            var selects = this.cache.advance.queryContainer.find(criteria);
            if (obj.type === 'remove') {
                obj.option = this.selectedFields[obj.index];
                delete this.selectedFields[obj.index];
            }
            if (obj.type === 'update' || obj.type === 'remove') {
                selects.find("option[value=\"" + obj.option + "\"]").removeAttr('disabled');
            }
            if (obj.type !== 'remove') {
                selects.find(options).attr('disabled', 'disabled');
            }
            selects.trigger('chosen:updated');
        };
        Search.prototype.rearrange = function () {
            var self = this;
            var menuUser = this.cache.advance.menuUser;
            var items = menuUser.clone();
            var content = $('<div>', {
                html: items,
                class: 'ez-advanced-search-rearrange-list'
            }).sortable({
                items: 'li:not(.heading)',
                axis: 'y'
            });
            this.dialog({
                html: content,
                title: 'Rearrange Querys',
                height: win.innerHeight(),
                width: 500,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Done',
                        class: 'btn-primary',
                        click: function () {
                            content = content.find('li');
                            menuUser.html(content);
                            rearrangeAjax.call(self, content);
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        Search.prototype.onOffRemoveBtn = function () {
            var advance = this.options.advance;
            var queryContainers = this.cache.advance.queryContainer.find(advance.queryrowContainer);
            $.each(queryContainers, function each() {
                var queryrow = $(this).find(">" + advance.queryrow) || 0;
                if (queryrow.length === 1) {
                    queryrow.find(advance.remove).addClass('hide');
                }
                else {
                    queryrow.find(advance.remove).removeClass('hide');
                }
            });
        };
        Search.prototype.onOffAddBtn = function (eventtype) {
            var maxQuerys;
            if (!this.maxQuerys) {
                return;
            }
            var btn = this.cache.advance.queryContainer.find(this.options.advance.add);
            maxQuerys = btn.data('maxQuerys');
            maxQuerys = +maxQuerys;
            if (eventtype === 'add') {
                // eslint-disable-next-line no-plusplus
                btn.data('maxQuerys', --maxQuerys);
            }
            if (eventtype === 'remove') {
                btn.removeAttr('disabled');
                // eslint-disable-next-line no-plusplus
                btn.data('maxQuerys', ++maxQuerys);
            }
            else if (maxQuerys === 0) {
                btn.attr('disabled', 'disabled');
            }
        };
        Search.prototype.resetcustomQueryObj = function (query) {
            if (!query) {
                customQueryObj.query = customQueryObj.dQuery || customQueryObj.query;
                delete customQueryObj.search;
                delete customQueryObj.dQuery;
                customQueryObj.readonly = false;
            }
            else {
                customQueryObj.search = true;
                customQueryObj.dQuery = customQueryObj.query;
                customQueryObj.query = query;
                customQueryObj.readonly = true;
            }
        };
        Search.prototype.reset = function (all) {
            if (all) {
                this.counter = 0;
                this.queryrowsCounts = 0;
            }
            else {
                this.cache.dates = [];
                this.cache.integer = [];
            }
        };
        return Search;
    }());
    function getDate(opr) {
        var date = 1000 * 3600 * 24 * opr;
        return new Date(new Date(this.value).valueOf() + date);
    }
    // AJAX FUNCTIONS
    // =========================
    function saveQueryAjax(options) {
        var formtype = $('#pageTemplateName').val();
        var self = this;
        $.ajax({
            type: 'POST',
            url: 'savesearchquery.htm',
            data: {
                queryName: options.name,
                query: options.query,
                role: pageParams.role || $('#role').val(),
                accountName: pageParams.account || $('#accountName').val(),
                tab: pageParams.tab || '',
                override: options.override,
                templateName: formtype
            },
            success: function (response) {
                var msg = '';
                var success = false;
                if (response.SUCCESS) {
                    success = true;
                    options.formtype = formtype;
                    msg = response.SUCCESS;
                }
                else if (response.ERROR) {
                    msg = response.ERROR;
                }
                else {
                    msg = response;
                }
                self.dialog({
                    html: msg,
                    title: 'Query Status',
                    buttons: {
                        Ok: function () {
                            if (success) {
                                self.saveQuerySuccess(options);
                            }
                            $(this).dialog('close');
                        }
                    }
                });
            },
            error: function (response) {
                self.dialog({
                    html: response,
                    title: 'Query Status',
                    buttons: {
                        Ok: function () {
                            $(this).dialog('close');
                        }
                    }
                });
            }
        });
    }
    function getQueryRowObj(options, index, value) {
        var operator = this.find("[name=" + options.oprprefix + index + "]").val();
        var lower = this.find("[name=" + options.lowerprefix + index + "]").val();
        var upper = this.find("[name=" + options.upperprefix + index + "]").val();
        // eslint-disable-next-line no-param-reassign
        value = value || this.find("[name=" + options.valueprefix + index + "]").val();
        var obj = {};
        if ((operator !== 'NN' &&
            operator !== 'IE' &&
            operator !== 'BTW' &&
            !value) ||
            (operator === 'BTW' && (!lower || !upper))) {
            obj = null;
        }
        else {
            obj = {
                value: encodeURIComponent(value || ''),
                operator: encodeURIComponent(operator || ''),
                lower: encodeURIComponent(lower || ''),
                upper: encodeURIComponent(upper || '')
            };
        }
        return obj;
    }
    function deleteQueryAjax(options) {
        var templateName = $('#pageTemplateName').val();
        var self = this;
        $.ajax({
            type: 'POST',
            url: 'deletesavedquery.htm',
            data: {
                queryName: options.name,
                role: pageParams.role || $('#role').val(),
                accountName: pageParams.account || $('#accountName').val(),
                templateName: templateName
            },
            success: function (response) {
                // remove the query from the list of saved query.
                if (response.SUCCESS) {
                    options.templateName = templateName;
                    self.deleteQuerySuccess(options);
                }
            }
        });
    }
    var rearrangeAjax = function (content) {
        var columnValue = [];
        var accountName = pageParams.account, role = pageParams.role, email = pageParams.email, tab = pageParams.tab;
        var obj = {
            accountName: accountName,
            role: role,
            email: email,
            tab: tab,
            action: 'usersearch'
        };
        $.each(content, function each() {
            var label = $(this).data('label');
            if (label) {
                columnValue.push(label);
            }
        });
        obj.columnValue = columnValue.toString();
        ezdia.util.saveUserSettings(obj);
    };
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        getQueryString: Search.prototype.getQueryString,
        search: Search.prototype.search,
        export: Search.prototype.exports,
        deleteQuery: Search.prototype.deleteQuery,
        setSelection: Search.prototype.setSelection,
        customSearch: Search.prototype.customSearch
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof Search) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new Search(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = Search;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
